import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import React from 'react'

import { useApartments, useSelectedApartment } from './apartmentStore'

// Building switcher shown in every apartment page header. Changing it updates
// the shared store, so every apartment page reflects the new building. The list
// is loaded from the backend (with the static seed list as fallback).
const ApartmentSelector = () => {
  const [apartment, setApartment] = useSelectedApartment()
  const apartments = useApartments()

  return (
    <FormControl variant="outlined" size="small" style={{ minWidth: 200 }}>
      <InputLabel>Apartment</InputLabel>
      <Select
        label="Apartment"
        value={apartment.id}
        onChange={(e) => setApartment(e.target.value)}
      >
        {apartments.map((a) => (
          <MenuItem key={a.id} value={a.id}>
            {a.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default ApartmentSelector
